// Ported from packages/desk/src/mobile/glyphs.tsx (docs/PLAN-2026-09-21-mobile-os-shell.md, step 4). Same file name and props
// as the desk copy, the dk- prefix renamed rdr-, so a fix in one is a copy in the other. Radar never imports @gamo/desk.
/** The few line icons the phone home screen draws itself (the dock, More, the chevrons). Stroke only, currentColor. */
import type { ReactNode } from "react";

function g(d: string, size = 22): ReactNode {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {d.split("|").map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}

export const HomeGlyph = () => g("M4 10.5 12 4l8 6.5|M6 9v10h4.5v-5h3v5H18V9");
export const SearchGlyph = () => g("M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z|M15.5 15.5 20 20");
export const ProfileGlyph = () => g("M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z|M4.5 20a7.5 7.5 0 0 1 15 0");
export const ChevronGlyph = () => g("M9 6l6 6-6 6", 18);
export const BackGlyph = () => g("M15 6l-6 6 6 6", 20);
export const BellGlyph = () => g("M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15z|M10 20a2 2 0 0 0 4 0");
export const CloseGlyph = () => g("M6 6l12 12M18 6 6 18", 18);

export function MoreGlyph(): ReactNode {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="5.5" cy="12" r="1.9" />
      <circle cx="12" cy="12" r="1.9" />
      <circle cx="18.5" cy="12" r="1.9" />
    </svg>
  );
}
